import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../client'
import type { NodeSearchResult, TaxonomyTreeResponse } from '../types'

export function useTaxonomyTree(schemeId?: string, enabled = true, vertical?: string) {
  return useQuery({
    queryKey: ['taxonomy-tree', schemeId, vertical],
    queryFn: async () => {
      // No `cache: 'no-cache'` here on purpose: the endpoint returns
      // `max-age=86400`, and forcing revalidation threw away a day of caching for a
      // round trip on every page that renders the category tree.
      const data = await apiFetch<TaxonomyTreeResponse>('api/v1/taxonomy/tree', {
        params: { scheme_id: schemeId, vertical },
      })
      return data.nodes
    },
    enabled,
  })
}

export function useTaxonomySearch(query: string) {
  return useQuery({
    queryKey: ['taxonomy-search', query],
    queryFn: () =>
      apiFetch<NodeSearchResult[]>('api/v1/taxonomy/search', {
        params: { q: query, limit: 10 },
        cache: 'no-cache',
      }),
    enabled: query.length >= 2,
  })
}
